import { DownOutlined } from '@ant-design/icons';
import { Tree } from 'antd';
import './CountryHierarchyTree.css';
import { DataFeedForm } from './DataFeedForm';

type countryTreeData = {
  title: string;
  key: string;
  children: countryTreeData[];
};

export const buildLocationTree = (formValues: DataFeedForm) => {
  const { dataset } = formValues;
  if (!formValues?.filters?.[dataset]?.countries) return [];

  return formValues.filters?.[dataset].countries.map((country) => ({
    title: `Country: ${country.label}`,
    key: `country-${country.value}`,
    children:
      formValues.filters?.[dataset].states[country.value]?.map((state) => ({
        title: `State: ${state.label}`,
        key: `state-${state.value}`,
        children:
          formValues.filters?.[dataset].cities[country.value]?.[
            state.value
          ]?.map((city) => ({
            title: `City: ${city.label}`,
            key: `city-${city.label}`,
          })) || [],
      })) || [],
  }));
};

export const CountryHierarchyTree = ({
  countryTreeData,
}: {
  countryTreeData: countryTreeData[];
}) => {
  return (
    <Tree
      className="hierarchy-tree bg-transparent"
      switcherIcon={<DownOutlined />}
      defaultExpandAll
      treeData={countryTreeData}
    />
  );
};
